module.exports = __webpack_public_path__ + "img/transfer8.79a8f453.jpeg";